import { Table, token } from '@zillow/constellation';
import React from 'react';
import { IOrderTaskData } from 'types/tasks';
import { CompleteTask } from './CompleteTask';
import { DeleteTask } from './DeleteTask';
import { DueDateDisplay, EditDueDateField } from './EditDueDate';
import { EditRoleDisplay, EditRoleField } from './EditRole';
import { EditTeammateDisplay, EditTeammateField } from './EditTeammate';
import { TaskEditForm } from './TaskEditForm';
import { EditTaskDescriptionDisplay } from './EditTaskDescription';
import styled from 'styled-components';
import { EditDueDateTimeDisplay, EditDueDateTimeField } from './EditDueDateTime';

export interface ITaskRowProps {
  tasks: IOrderTaskData[];
  highlightedTaskId?: string;
}

const StyledTableCell = styled(Table.Cell)<{ isHighlighted: boolean }>`
  background-color: ${({ isHighlighted }) => isHighlighted && (token('colors.backgroundPurple') as any)} !important;
`;

export const TaskRows: React.FC<ITaskRowProps> = ({ tasks, highlightedTaskId }) => {
  return (
    <>
      {tasks?.map((task) => (
        <Table.Row key={task.id}>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <CompleteTask task={task} />
          </StyledTableCell>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <EditTaskDescriptionDisplay task={task} setIsEditing={() => {}} />
          </StyledTableCell>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <TaskEditForm task={task} display={EditRoleDisplay} form={EditRoleField} />
          </StyledTableCell>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <TaskEditForm task={task} display={EditTeammateDisplay} form={EditTeammateField} />
          </StyledTableCell>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <TaskEditForm task={task} display={DueDateDisplay} form={EditDueDateField} />{' '}
            {task.dueDate && (
              <>
                at <TaskEditForm task={task} display={EditDueDateTimeDisplay} form={EditDueDateTimeField} />
              </>
            )}
          </StyledTableCell>
          <StyledTableCell isHighlighted={task.id === highlightedTaskId}>
            <DeleteTask task={task} />
          </StyledTableCell>
        </Table.Row>
      ))}
    </>
  );
};
